export default __webpack_public_path__ + "static/payment-validation-b5a2074c8e53bf09b8a22ff48fd01efc.webp";